import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * Input — single-line text input.
 *
 * @example
 *   <Input type="email" placeholder="E-Mail" value={...} onChange={...} />
 */
const Input = React.forwardRef(({ className, type = "text", ...props }, ref) => (
  <input
    ref={ref}
    type={type}
    className={cn(
      "w-full h-[3.6rem] px-[1.2rem] text-[1.3rem] bg-white",
      "border-[0.15rem] border-gray rounded-[0.8rem]",
      "outline-none transition-[border-color,box-shadow] duration-150",
      "placeholder:text-dim",
      "focus:border-primary focus:shadow-[0_0_0_0.3rem_rgba(200,212,0,0.15)]",
      "disabled:bg-bg disabled:cursor-not-allowed disabled:opacity-60",
      "font-[inherit]",
      className,
    )}
    {...props}
  />
));
Input.displayName = "Input";

const Label = React.forwardRef(({ className, ...props }, ref) => (
  <label
    ref={ref}
    className={cn(
      "block text-[1.1rem] font-semibold text-dim mb-[0.4rem]",
      className,
    )}
    {...props}
  />
));
Label.displayName = "Label";

const Textarea = React.forwardRef(({ className, ...props }, ref) => (
  <textarea
    ref={ref}
    className={cn(
      "w-full px-[1.2rem] py-[0.8rem] text-[1.3rem] bg-white",
      "border-[0.15rem] border-gray rounded-[0.8rem]",
      "outline-none transition-[border-color,box-shadow] duration-150 resize-y",
      "placeholder:text-dim",
      "focus:border-primary focus:shadow-[0_0_0_0.3rem_rgba(200,212,0,0.15)]",
      "disabled:bg-bg disabled:cursor-not-allowed disabled:opacity-60",
      "font-[inherit]",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";

export { Input, Label, Textarea };
